const getLevelOfNesting = (items, initialNestingLevel) =>
  items.reduce((levelOfNesting, item) => {
    const newLevelOfNesting = getLevelOfNesting(item.items, initialNestingLevel + 1);

    return Math.max(newLevelOfNesting, levelOfNesting);
  }, initialNestingLevel);

export default getLevelOfNesting;
